import { fetch } from '@atlassian/eoc-fetch';

import type { RelatedAlertGroupResponse } from '../../common/types';
import { withAIOpsDomainPrefix } from '../../common/utils';

export const getRelatedAlertGroup = (alertId: string): Promise<RelatedAlertGroupResponse> =>
	fetch<RelatedAlertGroupResponse>(
		withAIOpsDomainPrefix(`/v1/group-insights/get-group-of-alert?alertId=${alertId}`),
		{
			exactUrl: true,
		},
	);
